// extracted by css-extract-rspack-plugin
export default {"container":"kc1v1OFYnJQ4QMK_"};